module.exports = __webpack_public_path__ + "static/media/Jhin_0.6c9ae71f.jpg";